import { Stack } from "@mui/joy";
import { useSelector } from "react-redux";
import PlaceListDetail from "./PlaceListDetail";
import { useState } from "react";
import { isOpenNow } from "../../../utils/dataFormatter";
import SortMenu, { CORKAGE_FEE_ASC, CORKAGE_FEE_DESC, RESTAURANT_NAME_ASC, RESTAURANT_NAME_DESC } from "./SortMenu";
import PlaceCount from "./PlaceCount";
import NoPlacesFound from "./NoPlacesFound";

function PlaceList() {
  const [sortBy, setSortBy] = useState("None");
  const placeData = useSelector((state) => state.place.places);

  const filterPrice = useSelector((state) => state.filter.price);
  const filterOpenNow = useSelector((state) => state.filter.openNow);
  const filteredPlaceData = [...placeData].filter(
    (p) => filterPrice === null || p.corkageFee <= filterPrice,
  ).filter((p) => {
    if (filterOpenNow === null) { // filter is null means everything should be shown
      return true;
    } else {
      if (!("hoursOfOperation" in p)) { // if hoursOfOperation not available, don't show
        return false;
      } else {
        return isOpenNow(p.hoursOfOperation);
      }
    }
  });

  const sortedPlaceData = [...filteredPlaceData].sort((a, b) => {
    switch (sortBy) {
      case RESTAURANT_NAME_ASC:
        return a.name.localeCompare(b.name);
      case RESTAURANT_NAME_DESC:
        return b.name.localeCompare(a.name);
      case CORKAGE_FEE_ASC:
        return a.corkageFee - b.corkageFee;
      case CORKAGE_FEE_DESC:
        return b.corkageFee - a.corkageFee;
      default:
        return 0; // No sorting
    }
  });

  return (
    <Stack sx={{ width: "100%", padding: "20px" }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <PlaceCount placeData={sortedPlaceData} />
        <SortMenu sortBy={sortBy} setSortBy={setSortBy} />
      </Stack>
      {sortedPlaceData.length > 0 ? (
        sortedPlaceData.map((place, _index) => (
          <PlaceListDetail placeData={place} key={place.placeId} />
        ))
      ) : (
        <NoPlacesFound />
      )}
    </Stack>
  );
}

export default PlaceList;
